import React, { Component } from "react";
import Lib from "mon-entreprise";

import Input from "./component/input";

import "./App.css";

// const Lib = 0

export class App extends Component {
  constructor(props) {
    super(props);

    this.timeout = 0;
    this.defaultThrottle = 500; //In ms for debounce function
    this.decimals = 0; //How many decimals you want after coma
    this.defaultPeriod = "year"; //Change to "month" if you want default calcul to month;

    this.state = {
      total: "",
      // cout: "",
      brut: "",
      net: "",
      supernet: "",

      period: this.defaultPeriod
    };
  }

  onChangePeriod = () => {
    const { total, /*cout,*/ brut, net, supernet, period } = this.state;
    if (period === "year") {
      this.setState({
        total: (Number(total.replace(/\s/g, "")) / 12).toFixed(this.decimals),
        // cout: (cout / 12).toFixed(this.decimals),
        brut: (Number(brut.replace(/\s/g, "")) / 12).toFixed(this.decimals),
        net: (Number(net.replace(/\s/g, "")) / 12).toFixed(this.decimals),
        supernet: (Number(supernet.replace(/\s/g, "")) / 12).toFixed(
          this.decimals
        ),
        period: "month"
      });
    } else {
      this.setState({
        total: (Number(total.replace(/\s/g, "")) * 12).toFixed(this.decimals),
        // cout: (cout * 12).toFixed(this.decimals),
        brut: (Number(brut.replace(/\s/g, "")) * 12).toFixed(this.decimals),
        net: (Number(net.replace(/\s/g, "")) * 12).toFixed(this.decimals),
        supernet: (Number(supernet.replace(/\s/g, "")) * 12).toFixed(
          this.decimals
        ),
        period: "year"
      });
    }
  };

  formatNumber = s => {
    const formated = Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "EUR"
    }).format(s);
    return formated.substring(0, formated.length - 5);
  };

  onChangeTotal = e => {
    const val = Number(e.target.value.replace(/\s/g, "")).toFixed(this.decimals);
    this.setState({ total: val });
    if (this.timeout) clearTimeout(this.timeout);
    const { period } = this.state;
    this.timeout = setTimeout(() => {
      const cout = val * 0.94;
      let brut = parseFloat(
        Lib.evaluate("contrat salarié . rémunération . brut de base", {
          "contrat salarié . prix du travail":
            period === "year" ? cout / 12 : cout
        })
      );
      if (isNaN(brut)) brut = 0;
      let net = parseFloat(
        Lib.evaluate("contrat salarié . rémunération . net", {
          "contrat salarié . prix du travail":
            period === "year" ? cout / 12 : cout
        })
      );
      if (isNaN(net)) net = 0;
      let supernet = parseFloat(
        Lib.evaluate("contrat salarié . rémunération . net après impôt", {
          "contrat salarié . prix du travail":
            period === "year" ? cout / 12 : cout
        })
      );
      if (isNaN(supernet)) supernet = 0;
      this.setState({
        // cout: cout.toFixed(this.decimals),
        brut: (period === "year" ? brut * 12 : brut).toFixed(this.decimals),
        net: (period === "year" ? net * 12 : net).toFixed(this.decimals),
        supernet: (period === "year" ? supernet * 12 : supernet).toFixed(
          this.decimals
        )
      });
    }, this.defaultThrottle);
  };

  // onChangeCout = e => {
  //   const val = Number(e.target.value).toFixed(this.decimals);
  //   this.setState({ cout: val });
  //   if (this.timeout) clearTimeout(this.timeout);
  //   const { period } = this.state;
  //   this.timeout = setTimeout(() => {
  //     const total = (period === "year" ? val / 12 : val) / 0.94;
  //     let net = parseFloat(
  //       Lib.evaluate("contrat salarié . rémunération . net", {
  //         "contrat salarié . prix du travail":
  //           period === "year" ? val / 12 : val
  //       })
  //     );
  //     if (isNaN(net)) net = 0;
  //     let supernet = parseFloat(
  //       Lib.evaluate("contrat salarié . rémunération . net après impôt", {
  //         "contrat salarié . prix du travail":
  //           period === "year" ? val / 12 : val
  //       })
  //     );
  //     if (isNaN(supernet)) supernet = 0;
  //     this.setState({
  //       total: (period === "year" ? total * 12 : total).toFixed(this.decimals),
  //       net: (period === "year" ? net * 12 : net).toFixed(this.decimals),
  //       supernet: (period === "year" ? supernet * 12 : supernet).toFixed(this.decimals)
  //     });
  //   }, this.defaultThrottle);
  // };

  onChangeBrut = e => {
    const val = Number(e.target.value.replace(/\s/g, "")).toFixed(this.decimals);
    this.setState({ brut: val });
    if (this.timeout) clearTimeout(this.timeout);
    const { period } = this.state;
    this.timeout = setTimeout(() => {
      const cout = parseFloat(
        Lib.evaluate("contrat salarié . prix du travail", {
          "contrat salarié . rémunération . brut de base":
            period === "year" ? val / 12 : val
        })
      );
      const total = cout / 0.94;
      let net = parseFloat(
        Lib.evaluate("contrat salarié . rémunération . net", {
          "contrat salarié . rémunération . brut de base":
            period === "year" ? val / 12 : val
        })
      );
      if (isNaN(net)) net = 0;
      const supernet = parseFloat(
        Lib.evaluate("contrat salarié . rémunération . net après impôt", {
          "contrat salarié . rémunération . brut de base":
            period === "year" ? val / 12 : val
        })
      );
      this.setState({
        total: (period === "year" ? total * 12 : total).toFixed(this.decimals),
        // cout: (period === "year" ? cout * 12 : cout).toFixed(this.decimals),
        net: (period === "year" ? net * 12 : net).toFixed(this.decimals),
        supernet: (period === "year" ? supernet * 12 : supernet).toFixed(
          this.decimals
        )
      });
    }, this.defaultThrottle);
  };

  onChangeNet = e => {
    const val = Number(e.target.value.replace(/\s/g, "")).toFixed(this.decimals);
    this.setState({ net: val });
    if (this.timeout) clearTimeout(this.timeout);
    const { period } = this.state;
    this.timeout = setTimeout(() => {
      const cout = parseFloat(
        Lib.evaluate("contrat salarié . prix du travail", {
          "contrat salarié . rémunération . net":
            period === "year" ? val / 12 : val
        })
      );
      const total = cout / 0.94;
      let brut = parseFloat(
        Lib.evaluate("contrat salarié . rémunération . brut de base", {
          "contrat salarié . rémunération . net":
            period === "year" ? cout / 12 : cout
        })
      );
      if (isNaN(brut)) brut = 0;
      const supernet = parseFloat(
        Lib.evaluate("contrat salarié . rémunération . net après impôt", {
          "contrat salarié . rémunération . net":
            period === "year" ? val / 12 : val
        })
      );
      this.setState({
        total: (period === "year" ? total * 12 : total).toFixed(this.decimals),
        // cout: (period === "year" ? cout * 12 : cout).toFixed(this.decimals),
        brut: (period === "year" ? brut * 12 : brut).toFixed(this.decimals),
        supernet: (period === "year" ? supernet * 12 : supernet).toFixed(
          this.decimals
        )
      });
    }, this.defaultThrottle);
  };

  onChangeSupernet = e => {
    const val = Number(e.target.value.replace(/\s/g, "")).toFixed(this.decimals);
    this.setState({ supernet: val });
    if (this.timeout) clearTimeout(this.timeout);
    const { period } = this.state;
    this.timeout = setTimeout(() => {
      const cout = parseFloat(
        Lib.evaluate("contrat salarié . prix du travail", {
          "contrat salarié . rémunération . net après impôt":
            period === "year" ? val / 12 : val
        })
      );
      const total = cout / 0.94;
      let brut = parseFloat(
        Lib.evaluate("contrat salarié . rémunération . brut de base", {
          "contrat salarié . rémunération . net après impôt":
            period === "year" ? cout / 12 : cout
        })
      );
      if (isNaN(brut)) brut = 0;
      const net = parseFloat(
        Lib.evaluate("contrat salarié . rémunération . net", {
          "contrat salarié . rémunération . net après impôt":
            period === "year" ? val / 12 : val
        })
      );
      this.setState({
        total: (period === "year" ? total * 12 : total).toFixed(this.decimals),
        // cout: (period === "year" ? cout * 12 : cout).toFixed(this.decimals),
        brut: (period === "year" ? brut * 12 : brut).toFixed(this.decimals),
        net: (period === "year" ? net * 12 : net).toFixed(this.decimals)
      });
    }, this.defaultThrottle);
  };

  render() {
    const { total, /*cout,*/ brut, net, supernet, period } = this.state;
    return (
      <div className="App">
        <label>
          <input
            type="radio"
            value="month"
            checked={period === "month"}
            onChange={() => this.onChangePeriod()}
          />
          Par mois
        </label>
        <label>
          <input
            type="radio"
            value="year"
            checked={period === "year"}
            onChange={() => this.onChangePeriod()}
          />
          Par an
        </label>
        <Input
          label="Coût total dépensé par l'entreprise"
          type="total"
          value={this.formatNumber(total)}
          placeholder="ex: 1000€"
          onChange={e => this.onChangeTotal(e)}
        />
        {/* <Input
          label="Coût total dépensé par l'employeur"
          type="cout"
          value={cout}
          placeholder="ex: 1000€"
          onChange={e => this.onChangeCout(e)}
        /> */}
        <Input
          label="Salaire brut"
          type="brut"
          value={this.formatNumber(brut)}
          placeholder="ex: 1000€"
          onChange={e => this.onChangeBrut(e)}
        />
        <Input
          label="Salaire net avant impôt"
          type="net"
          value={this.formatNumber(net)}
          placeholder="ex: 1000€"
          onChange={e => this.onChangeNet(e)}
        />
        <Input
          label="Salaire net après impôt (pour un(e) célibataire)"
          type="supernet"
          value={this.formatNumber(supernet)}
          placeholder="ex: 1000€"
          onChange={e => this.onChangeSupernet(e)}
        />
      </div>
    );
  }
}

export default App;
